"use strict";

/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
'use strict';
var angular = require('angular');
function makeArray(arr) {
  if (!arr) {
    return [];
  }
  return angular.isArray(arr) ? arr : [arr];
}
function provideRootElement(modules, element) {
  element = angular.element(element);
  modules.unshift(['$provide', function ($provide) {
    $provide.value('$rootElement', element);
  }]);
}
function createInjector(injectorModules, element) {
  var modules = ['ng'].concat(makeArray(injectorModules));
  if (element) {
    provideRootElement(modules, element);
  }
  return angular.injector(modules);
}
function bootstrapApplication(angularApp) {
  angular.element(document).ready(function () {
    angular.bootstrap(document, [angularApp], {
      strictDi: true
    });
  });
}
module.exports = function (app, modules) {
  var injector = createInjector(modules),
    $q = injector.get('$q'),
    promises = [],
    errorCallback = angular.noop,
    loadingCallback = angular.noop,
    doneCallback = angular.noop;
  return {
    resolve: function resolve(promise) {
      promise = $q.when(injector.instantiate(promise));
      promises.push(promise);
      return this;
    },
    bootstrap: function bootstrap() {
      loadingCallback();
      return $q.all(promises).then(function () {
        return bootstrapApplication(app);
      })["catch"](errorCallback)["finally"](doneCallback);
    },
    loading: function loading(callback) {
      loadingCallback = callback;
      return this;
    },
    done: function done(callback) {
      doneCallback = callback;
      return this;
    },
    error: function error(callback) {
      errorCallback = callback;
      return this;
    }
  };
};